var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('label',{staticClass:"file-input-label",attrs:{"for":"file-input"},on:{"dragover":function($event){$event.preventDefault();},"drop":_vm.handleDrop}},[_vm._v("\n    "+_vm._s(_vm.placeholder)+"\n  ")]),_c('input',{staticClass:"file-input",attrs:{"id":"file-input","type":"file","multiple":""},on:{"change":_vm.handleFileUpload}})])
}
var staticRenderFns = []

export { render, staticRenderFns }